<template>
    <button
        type="button"
        class="btn btn-default btn-sm"
        aria-label="Priljubljena različica"
        @click.prevent="markAsBestVersion">
        <i
            v-if="rowData.best"
            class="fa fa-star text-orange"
            aria-hidden="true"/>
        <i
            v-else
            class="fa fa-star-o text-orange"
            aria-hidden="true"/>
    </button>
</template>

<script>
export default {
    name: 'BestVersionAction',

    props: {
        rowData:  {
            type:     Object,
            required: true
        },
        rowIndex: {
            type:    Number,
            default: 0
        }
    },

    methods: {
        markAsBestVersion() {
            this.$events.fire('markAsBestVersion', this.rowData, true);
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/Actions/BestVersion.vue